import firstUpperCase from "./firstUpperCase"
export default function getPadding(dom,dir=top){
	const style = getComputedStyle(dom);
	if(!style) return 0;
	dir = firstUpperCase(dir);
	const key = `padding${dir}`;
	const padding = style[key];
	if(!padding) return 0;
	return padding.replace("px","") * 1;
}